import React, { useEffect, useLayoutEffect } from "react";
import PullToRefresh from "react-simple-pull-to-refresh";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDetailBranchPageScroll,
  fetchBranchVoucherInfo,
} from "redux/slices/sales/salesSlice";

import { isBranchPermission } from "utils/define";
import { useManagerPaymentQuery } from "queries/Sales/useManagerPaymentQuery";
import { toReferenceDate, PERIOD_COUNT } from "pages/Sales/_lib/toReferenceDate";

import MainLayout from "layouts/MainLayout";
import SummaryInfo from "../period/SummaryInfo";
import BranchDetailList from "./BranchDetailList";
import PullToRefreshing from "components/common/PullToRefreshing";

/**
 * [전지점 이용권 종류별 매출]
 */

export const BranchDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { searchPartner, searchDate, searchPeriodType } = useSelector(
    (state) => state.sales.branchVoucherInfo
  );
  const partnerInfo = useSelector((state) => state.partner);
  const salesInfo = useSelector((state) => state.sales);

  const periodType = searchPeriodType || salesInfo.searchPeriodType || "daily";

  useLayoutEffect(() => {
    return () => {
      dispatch(fetchDetailBranchPageScroll("store"));
    };
  }, []);

  useEffect(() => {
    if (!searchPartner) {
      dispatch(
        fetchBranchVoucherInfo({
          searchPartner: partnerInfo.seqPartner,
          searchDate: salesInfo.searchDate,
          searchPeriodType: salesInfo.searchPeriodType,
        })
      );
    }
    if (!isBranchPermission(partnerInfo)) {
      navigate("/sales");
    }
  }, []);

  const query = useManagerPaymentQuery({
    seqPartner: searchPartner || partnerInfo.seqPartner,
    periodType,
    referenceDate: searchDate ? toReferenceDate(periodType, searchDate) : "",
    periodCount: PERIOD_COUNT[periodType],
    // seqPartnerBranches 생략 → 본점 전체(branchServiceBreakdown 포함)
  });

  const data = query.data
    ? {
        totalAmount: query.data.totalAmount,
        serviceBreakdown: query.data.serviceBreakdown,
      }
    : undefined;

  const eventHandler = {
    changeDate: (date) => {
      dispatch(fetchBranchVoucherInfo({ searchDate: date }));
    },
    pullToRefresh: () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          query.refetch();
          resolve();
        }, 700);
      });
    },
  };

  const render = () => {
    return (
      <PullToRefresh
        onRefresh={eventHandler.pullToRefresh}
        resistance={2}
        pullingContent={<></>}
        refreshingContent={<PullToRefreshing />}
      >
        <MainLayout
          withHeader={true}
          headerProps={{
            withBackButton: true,
            centerTitle: "전 지점 이용권 종류별 매출",
          }}
          backgroundColor="white"
          withBottomTab={false}
        >
          <SummaryInfo
            mode={periodType}
            date={searchDate}
            data={data}
            isChart={false}
            isLoading={query.isLoading}
            isError={query.isError}
            onChange={eventHandler.changeDate}
            onRefresh={() => query.refetch()}
          />
          <BranchDetailList
            branches={query.data?.branchServiceBreakdown?.branches || []}
            searchPartner={searchPartner || partnerInfo.seqPartner}
            searchDate={searchDate}
          />
        </MainLayout>
      </PullToRefresh>
    );
  };

  return render();
};

export default BranchDetail;
